module.exports = __webpack_public_path__ + "img/ad5a26b3abd7ca1499f14bd4cdee926c.png";